<nz-drawer
    [nzTitle]="drawerTitle"
    [nzVisible]="openDrawer"
    nzHeight="80%"
    [nzClosable]="true"
    nzPlacement="bottom"
    (nzOnClose)="close()">
    <div *nzDrawerContent>
        @if (openDrawer) {
            @if (loading) {
                <nz-spin
                    style="height: 5rem; padding: var(--pf-section-gap)"
                    nzTip="Fetching contacts for {{ entityName }}"></nz-spin>
            }
            <platform-associated-contacts-form
                [control]="control"
                [columns]="columns"
                [baseEntityPlatform]="baseEntityPlatform"
                [baseEntityType]="baseEntityType"
                [postSaveFn]="postSaveContactFn"
                [postDeleteFn]="deleteContact">
            </platform-associated-contacts-form>
        }
    </div>
</nz-drawer>
